import {
  Tag, TagLabel, TagProps, TagCloseButton, Box,
} from "@chakra-ui/react";
import { sizeMap } from "helpers/tag";
import { ReminderSchema } from "features/Resources/TaskTemplate/schema";
import generateSchedulingSummary from "features/Trigger/helpers";
import SkeletonTag from "./SkeltonTag";

export interface TemplateReminderTagProps extends TagProps {
  index: number;
  reminder: ReminderSchema;
  onRemove?: () => void;
  tagLabelProps?: object;
  size?: "sm" | "md";
  removeable?: boolean;
}

export default function TemplateReminderTag({
  index,
  reminder,
  onRemove = () => {},
  tagLabelProps = {},
  size = "md",
  removeable = false,
  ...props
}: TemplateReminderTagProps) {
  if (!reminder) {
    return <SkeletonTag />;
  }
  const { tagSizeProps, tagLabelSizeProps } = sizeMap(size);

  let descriptor = "";
  if (reminder?.remindAtTrigger && reminder?.remindAtTrigger?.data) {
    descriptor = ` ${generateSchedulingSummary({ field: "remindAtTrigger", trigger: reminder.remindAtTrigger })}`;
  }
  return (
    <Tag size="lg" cursor="pointer" colorScheme="gray" maxWidth="none" {...tagSizeProps} {...props}>
      <TagLabel
        fontWeight="normal"
        {...tagLabelSizeProps}
        {...tagLabelProps}
      >
        <Box as="span" fontWeight="500">
          {`Reminder ${index + 1}:`}
        </Box>
        {" "}
        {descriptor}
      </TagLabel>
      {removeable && <TagCloseButton onClick={onRemove} />}
    </Tag>
  );
}
